<template>
  <div class="selects">
    <!-- 选择框 -->
    <div
      :class="{selects0show: !isshow,selects0hade: isshow}"
      class="selects0"
      @click="isshow=!isshow"
    >
      <p v-text="xz"></p>
      <img src="@/assets/img/icon_select.png" alt srcset />
    </div>
    <!-- 下拉框大盒子 -->
    <div
      :class="{show: !isshow,hade: isshow,issel:num>=4}"
      class="sel"
    >
      <!-- 下拉框 -->
      <div
        @click="cutValue(i)"
        :style="{display: num >=(i+1)?'block':'none'}"
        v-for="(item,i) in num"
        :key="i"
        v-text="sel[i]"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //显示多少个下拉框
    num: {
      type: Number,
      required: true //必传
    }, 
    //下拉框显示的数据
    sel: {
      type: Array,
      required: true //必传
    }
  },
  data() {
    return {
      isshow: true, //控制下拉框显示及隐藏
      xz: "全集團" //默认展示的内容
    };
  },
  methods: {
    //点击换文字的方法
    cutValue(val) {
      this.isshow = true;
      this.xz = this.sel[val]; //拿到父组件传来的数据
      this.$emit("va", val, this.sel[val]);
    }
  }
};
</script>
<style scoped>
.show {
  display: block;
}
.hade {
  display: none;
}
.selects0show {
  /* border: 1px solid #01be6e; */
}
.selects0hade {
  border: 1px solid #e4e4e4;
}
.selects {
  width: 100%;
  height: 100%;}
  .selects0 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #100316;
    border-radius: 50px;
    text-align: center;
    position: relative;
    }
    p {
      line-height: 100%;
      display: inline;
      color: #fff;   
      font-size: 16px;  
      /* padding-left: 10px; */
    }
    img {
      width: 8%;
      /* margin-right: 10px; */
      transform: translateY(-50%);
      position: absolute;
      top: 50%;
      right: 2%;
    }
 
  /* .issel {
    height: 140px !important;
  } */
  .sel {
    width: 100%;
    background: #4C4C4D;
    border-radius: 0 0 20px 20px;
    padding: 20px 0;
    position: absolute;
    top: 28px;
    z-index: -1;
    box-shadow: 0px 10px 36px -10px rgba(0, 0, 0, 0.80);
    -webkit-box-shadow: 0px 10px 36px -10px rgba(0, 0, 0, 0.80);
    transition: all 0.2s ease-in;
    /* margin-top: -20px; */
    /* z-index: -1;
    top: 28px; */
    /* position: absolute; */
    /* height: 140px; */
    /* overflow: auto; */
     /* border: 1px solid #01be6e; */
     /* border-top: none; */
  }
  .sel div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 50px;
      /* padding-left: 10px; */
      color: #fff;
      text-align: center;
      font-size: 16px;
  }
  .sel div:hover{
      background: #ffffff;  
      color: #4C4C4D;
  }
  /* .sel {
    width: 100%;
    height: 140px;
    overflow: auto;
    border: 1px solid #01be6e; 
    border-top: none; }
    div {
      width: 100%;
      height: 35px; 
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 35px;
      padding-left: 10px;
      background: white; 
    }
    div:hover {
      background: #01be6e;  
      color: white;
    }
    .selects0:hover {
      background: white;
    } */
 
  /* // .sel::-webkit-scrollbar {
  //   display: none;
  // }
} */
</style>